<template>
  <div id="error" class="container h-100">
    <ErrorMessageAlert v-if="errorMessage" :error-message="errorMessage" />
    <h3>{{ heading ?? translate('There was an error while loading the page.') }}</h3>
    <p>
      {{ translate('Let us know using the  ') }}
      <a class="" style="cursor: pointer" @click="feedbackOpen">{{ translate('feedback') }}</a>
      {{ translate(' function if you think this is a mistake') }}.
    </p>
    <router-link to="/">{{ translate('Return to the homepage') }}.</router-link>
  </div>
</template>
<script setup lang="ts">
import {
  feedbackOpenKey,
  FeedbackOpen,
} from '@/components/shared/custom/FeedbackSlideIn/injectionKeys';
const feedbackOpen = inject<FeedbackOpen>(feedbackOpenKey) as FeedbackOpen;
const {translate} = useLocalisation();
defineProps<{heading?: string; errorMessage?: string}>();
</script>
